/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const AlignRightOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.625 3.75v16.5m-3.75-9.75h-9a.753.753 0 0 1-.75-.75V6c0-.41.336-.75.75-.75h9c.414 0 .75.34.75.75v3.75c0 .41-.336.75-.75.75zm-12.75 3h12.75c.414 0 .75.34.75.75V18c0 .41-.336.75-.75.75H4.125a.753.753 0 0 1-.75-.75v-3.75c0-.41.336-.75.75-.75z"
})));
// Fill
const AlignRightFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M21.375 3.75v16.5a.751.751 0 0 1-1.5 0V3.75a.751.751 0 0 1 1.5 0zm-4.5.75h-9c-.398 0-.779.16-1.061.44-.281.28-.439.66-.439 1.06v3.75c0 .4.158.78.439 1.06.282.28.663.44 1.061.44h9c.398 0 .779-.16 1.061-.44.281-.28.439-.66.439-1.06V6c0-.4-.158-.78-.439-1.06a1.508 1.508 0 0 0-1.061-.44zm0 8.25H4.125c-.398 0-.779.16-1.061.44-.281.28-.439.66-.439 1.06V18c0 .4.158.78.439 1.06.282.28.663.44 1.061.44h12.75c.398 0 .779-.16 1.061-.44.281-.28.439-.66.439-1.06v-3.75c0-.4-.158-.78-.439-1.06a1.508 1.508 0 0 0-1.061-.44z"
})));
// DuoTone
const AlignRightDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M7.875 10.5h9c.414 0 .75-.34.75-.75V6c0-.41-.336-.75-.75-.75h-9c-.414 0-.75.34-.75.75v3.75c0 .41.336.75.75.75zm9 3H4.125c-.414 0-.75.34-.75.75V18c0 .41.336.75.75.75h12.75c.414 0 .75-.34.75-.75v-3.75c0-.41-.336-.75-.75-.75z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.625 3.75v16.5m-3.75-9.75h-9a.753.753 0 0 1-.75-.75V6c0-.41.336-.75.75-.75h9c.414 0 .75.34.75.75v3.75c0 .41-.336.75-.75.75zm-12.75 3h12.75c.414 0 .75.34.75.75V18c0 .41-.336.75-.75.75H4.125a.753.753 0 0 1-.75-.75v-3.75c0-.41.336-.75.75-.75z"
})));
/**
  Icon AlignRightIcon in design group
*/
export const AlignRightIcon = createIcon('AlignRightIcon', 'align-right', 'design', AlignRightOutline, AlignRightFill, AlignRightDuotone, "0 0 24 24");